{
  "title": "Scraping dashboard",
  "subtitle": "Every scraping run: how each website did and which ads it found.",
  "back": "All runs",
  "status": {
    "completed": "Completed",
    "partial": "Partial",
    "failed": "Failed",
    "running": "Running",
    "success": "Success",
    "blocked": "Blocked",
    "pending": "Pending",
    "not_run": "Not run"
  },
  "scrapers": {
    "immobilier_ch": "Immobilier.ch",
    "homegate_ch": "Homegate.ch",
    "comparis_immobilier": "Comparis",
    "properstar_ch": "Properstar.ch",
    "anibis_ch": "Anibis.ch",
    "immoscout24_ch": "ImmoScout24.ch",
    "newhome_ch": "Newhome.ch"
  },
  "trigger": {
    "scheduled": "Scheduled",
    "manual": "Manual"
  },
  "singleScraper": "Single scraper: {{name}}",
  "singleScraperBanner": "Only {{name}} ran in this run; the other scrapers were not run.",
  "noBreakdown": "No detailed breakdown for this run",
  "list": {
    "filters": {
      "status": "Status",
      "scraper": "Scraper",
      "scope": "Scope",
      "all": "All",
      "fullRuns": "All scrapers",
      "singleRuns": "Single scraper"
    },
    "empty": "No scraping runs yet",
    "columns": {
      "run": "Run",
      "started": "Started",
      "status": "Status",
      "scrapers": "Scrapers",
      "site": "On site",
      "parsed": "Parsed",
      "filtered": "Filtered out",
      "imported": "Imported",
      "updated": "Updated",
      "unchanged": "Unchanged",
      "merged": "Merged",
      "duration": "Duration"
    }
  },
  "detail": {
    "title": "Run #{{id}}",
    "started": "Started {{date}}",
    "invalidRun": "Invalid run identifier",
    "viewRunLog": "Run logs",
    "runError": "Run error",
    "legacy": "This run predates the detailed breakdown: only the totals are available."
  },
  "summary": {
    "siteReported": "On site",
    "parsed": "Parsed",
    "dropped": "Dropped",
    "filteredOut": "Filtered out",
    "imported": "Imported",
    "updated": "Updated",
    "unchanged": "Unchanged",
    "merged": "Merged",
    "failed": "Failed",
    "duration": "Total time"
  },
  "breakdown": {
    "title": "Scrapers",
    "viewLog": "Logs",
    "columns": {
      "scraper": "Scraper",
      "status": "Status",
      "site": "On site",
      "parsed": "Parsed",
      "dropped": "Dropped",
      "filtered": "Filtered out",
      "returned": "Returned",
      "imported": "Imported",
      "updated": "Updated",
      "unchanged": "Unchanged",
      "merged": "Merged",
      "retired": "Retired",
      "failed": "Failed",
      "duration": "Duration",
      "perAd": "Per ad",
      "error": "Error"
    }
  },
  "ads": {
    "title": "Ads",
    "scraper": "Scraper",
    "allScrapers": "All scrapers",
    "outcomes": {
      "imported": "Imported",
      "updated": "Updated",
      "unchanged": "Unchanged",
      "merged": "Merged",
      "filtered_out": "Filtered out",
      "dropped": "Dropped",
      "failed": "Failed"
    },
    "columns": {
      "title": "Ad",
      "scraper": "Scraper",
      "price": "Price",
      "rooms": "Rooms",
      "size": "Size",
      "details": "Details",
      "time": "Time",
      "links": "Links"
    },
    "untitled": "Untitled ad",
    "empty": "No ads in this category",
    "openInApp": "Open in app",
    "openOnSite": "Open on site",
    "mergedInto": "Merged into ad #{{id}}",
    "viewLog": "Logs",
    "timeTooltip": "Detail page {{scrape}}, import {{import}}"
  },
  "logs": {
    "runTitle": "Run #{{id}} logs",
    "scraperTitle": "Run #{{id}}: {{name}} logs",
    "itemTitle": "Run #{{id}}: ad logs"
  }
}
